import s from './Skeleton.module.css'

/** A grey placeholder in the shape of what's loading. Screens get these from <Screen>; reach for it directly rarely. */
export function Skeleton(props: { height?: 'line' | 'stat' | 'block' | 'tall'; label?: string }) {
  return <div className={s[props.height ?? 'block']} aria-busy="true" aria-label={props.label ?? 'Loading'} role="status" />
}
